<div class="row">
    <div class="content-container col-3">
        <div class="title pb-0 d-flex justify-content-center text-uppercase">
            Standard Sample Menu
        </div>
        <div class="content d-flex flex-wrap">
            @for (menu of standardSampleMenu; track menu; let i = $index) {
                <div class="menu-block" [ngClass]="{'selected-menu-block': menu.value == selectedStandardMenuItem}">
                    <button id="i" (click)="onStandardMenuSelection(menu.value)" [class.active]="menu.value === selectedStandardMenuItem">
                        {{ menu.text }}
                    </button>
                </div>
            }
        </div>
    </div>
    <div class="col-3">
        <div class="content-container">
            <div class="title pb-0 d-flex justify-content-center text-uppercase">
                Enrolment Menu
            </div>
            <div class="menu-container mb-2">
            @for (benefitCategory of benefitCategories; track benefitCategory) {
                <div
                class="menu-selection"
                    [ngClass]="{'active': benefitCategory.id == selectedCategoryId,
                            'required': benefitCategory.isRequired,
                            'completed': benefitCategory.isCompleted,
                            'disabled': benefitCategory.isDisabled
                        }" (click)="categoryChange(benefitCategory)">
                <div class="select-left-tab">
                    @if (benefitCategory.isCompleted) {
                        <mwp-svg-icon [SvgMatType]="svgType.CheckMark"/>
                    }
                    @if (benefitCategory.isRequired && !benefitCategory.isCompleted) {
                        <div class="requiredCircle">
                            <div class="redCircle"></div>
                        </div>
                    }
                    @if (!benefitCategory.isRequired && !benefitCategory.isCompleted) {
                        <div class="no-format"></div>
                    }
                </div>
                <div class="select-right-tab">
                    <span>
                    {{ benefitCategory.name }}
                    </span>
                </div>
                </div>
            }
            </div>
        </div>
    </div>
</div>